import React from 'react';
import './Header.css';

function Header() {
    return (
        <header className="Header">
            Pivo Samstig Game
        </header>
    );
}

export default Header;
